var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgReply = function SvgReply(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 14,
    "data-width-24": 18,
    viewBox: "0 0 18 16.1",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.334 13.477a.61.61 0 0 0 .488 0 .665.665 0 0 0 .206-1.069L2.224 7.463h8.597c.962 0 2.356.383 3.508 1.531 1.138 1.135 2.104 3.084 2.104 6.336a.7.7 0 1 0 1.4 0c0-3.543-1.062-5.878-2.516-7.327-1.441-1.437-3.204-1.94-4.496-1.94H2.208l4.82-4.961a.666.666 0 0 0-.016-.91.63.63 0 0 0-.884-.016L.186 6.292a.665.665 0 0 0 0 .926l5.942 6.116q.09.093.206.143",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReply);
export default ForwardRef;